export default {
   // 成员角色
   Role: {
      Creator: 1,
      Manager: 2,
      Grapher: 4,
      Retoucher: 8,
      roleName: {
         1: "创建者",
         2: "管理者",
         4: "摄影师",
         8: "修图师"
      },
      roleIcon: {
         4: "camera",
         8: "scissor"
      },
      getName(role) {
         return this.roleName[role];
      },
      isManager(roles) {
         return roles.indexOf(this.Manager) !== -1;
      },
      isGrapher(roles) {
         return roles.indexOf(this.Grapher) !== -1;
      },
      isRetoucher(roles) {
         return roles.indexOf(this.Retoucher) !== -1;
      }
   },
   Upload: {
      TypeHD: "HD", // 高清图上传
      TypeRaw: "RAW", // RAW上传
      TypeOrigin: "ORI", // 原始图上传
      labels: {
         "HD": "高清",
         "RAW": "RAW",
         "ORI": "原图"
      },
      isHD(type) {
         return type === this.TypeHD;
      },
      isRaw(type) {
         return type === this.TypeRaw;
      },
      isOrigin(type) {
         return type === this.TypeOrigin;
      },
      label(type) {
         return this.labels[type];
      }
   },
   Suffix: {
      isImg(suffix) {
         return ["JPG", "JPEG", "PNG", "GIF", "SVG", "WEBP"].indexOf(suffix.toUpperCase()) !== -1
      },
      isRaw(suffix) {
         return ["RAF", "CRW", "CR2", "CR3", "KDC", "MRW", "NEF", "CRF", "DNG", "PTX", "PEF", "ARW", "X3F", "RW2"].indexOf(suffix.toUpperCase()) !== -1;
      },
   },
   Retouch: {
      labels: {
         1: "未修图",
         2: "修图中",
         3: "已修图"
      }
   },
   Income: {
      Type: {
         labels: {
            100: "照片付费",
            101: "账户充值",
            200: "提现转出",
            201: "信用支付",
         },
         options() {
            return [
               {
                  label: "收入",
                  options: [
                     {label: "照片付费", value: 100},
                     {label: "账户充值", value: 101}
                  ]
               },
               {
                  label: "支出",
                  options: [
                     {label: "提现转出", value: 200},
                     {label: "信用支付", value: 201}
                  ]
               }
            ];
         },
      },
   },
   Platform: parseInt(process.env.VUE_APP_PLATFORM),
}
